var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.625,17H16a1,1,0,0,1,0-2h2.626A3.488,3.488,0,0,0,22,11.182a4.849,4.849,0,0,0-4.867-4.819,2.56,2.56,0,0,0-.263.015,1,1,0,0,1-1.053-.66A5.605,5.605,0,0,0,4.934,7.546,4.914,4.914,0,0,0,5,8.338a1,1,0,0,1-.676,1.11A3.358,3.358,0,0,0,2,12.637C2,14.83,4.3,15,5,15H8a1,1,0,0,1,0,2H5c-2.991,0-5-1.753-5-4.363A5.346,5.346,0,0,1,2.941,7.862c0-.106-.007-.211-.007-.316A7.606,7.606,0,0,1,17.423,4.369,6.85,6.85,0,0,1,24,11.182C24,14.5,21.689,17,18.625,17ZM8.293,11.293l3-3a1,1,0,0,1,1.414,0l3,3a1,1,0,1,1-1.414,1.414L13,11.414V18a1,1,0,0,1-2,0V11.414L9.707,12.707a1,1,0,0,1-1.414-1.414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.fe899af059e742b9c579149758f6c31b.svg";
export { ForwardRef as ReactComponent };